import React, { useContext, useEffect, useState } from "react"
import { v4 } from 'uuid'
import { isMobileOnly } from "react-device-detect"
import { Dropdown } from 'rsuite'
import { SEARCH, SearchContext } from './SearchContext'
import List from "../common/icons/List"
import Grid from "../common/icons/Grid"
import Pin from "../common/icons/Pin"
import FilterResultsIcon from './filtering/FilterResultsIcon'
import {default as SortIcon} from '../common/icons/Sort'

const _sortDropdownOptions = [
  {icon: "fas fa-crown", value: "preferred", label: "Preferred Hotels"},
  {icon: "fas fa-sort-amount-up", value: "price-low-high", label: "Price (low to high)"},
  {icon: "fas fa-sort-amount-down", value: "price-high-low", label: "Price (high to low)"},
  {icon: "fas fa-sort-alpha-down", value: "a-z", label: "A-Z"},
  {icon: "fas fa-sort-alpha-up", value: "z-a", label: "Z-A"},
]

const SearchFilter = () => {
  const { state, dispatch } = useContext(SearchContext)
  const [smallScreen, setSmallScreen] = useState(isMobileOnly)
  const _setFiltersOpen = (open) => dispatch({ type: SEARCH.FILTERS.OPEN, payload: open})
  const _initiateFilterSearch = (payload) => dispatch({ type: SEARCH.FILTERS.SEARCH, payload })
  const _setSort = (sort) => {
    dispatch({ type: SEARCH.SORT.SET, payload: sort})
    _initiateFilterSearch({value: true})
  }
  const setLayout = (layout) => dispatch({ type: SEARCH.LAYOUT.SET, payload: layout })
  const [filtersIconActive, setFiltersIconActive] = useState(false)

  const __getSortIcon = () => {
    if (state.sort) {
      let item = _sortDropdownOptions.filter(x => x.value == state.sort)
      return <i className={item[0].icon} />
    } else {
      return <SortIcon />
    }
  }
  const [mainSortIcon, setMainSortIcon] = useState(__getSortIcon())

  useEffect(() => {
    window.onresize = _resizeActions
    _resizeActions()
  }, [])

  const _handleMapButtonClick = () => {
    setLayout('map')
    dispatch({ type: SEARCH.HOTEL.SET, payload: null })
    dispatch({ type: SEARCH.POP_UP_OPEN.SET, payload: false })
  }

  const _resizeActions = () =>
    setSmallScreen(isMobileOnly || window.innerWidth < 765)

  const _renderPageInfo = () => state.meta && (
    <small>
      <span>{!isMobileOnly && "Showing"} page {state.meta.current_page} of {state.meta.total_pages}</span>
    </small>
  )

  const _toggleFilterResults = () => _setFiltersOpen(!state.filtersOpen)

  const __handleSortClick = (item) => {
    _setSort(item.value)
    setMainSortIcon(<i className={item.icon} />)
    setDropdownOpen(false)
  }

  useEffect(() => {
    setFiltersIconActive(state.initiateFilterSearch)
  }, [state.initiateFilterSearch])

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen)
  }

  const dropdownPlacement = isMobileOnly? 'bottom-end' : 'bottom-start'
  const dropdownClasses = `rs-dropdown rs-dropdown-placement-${dropdownPlacement} rs-dropdown-no-caret`

  return (
    <div className="filter toolbar">
      <h2><span>{state.meta && state.meta.total_count} Hotels</span> { _renderPageInfo() } </h2>

      <nav className="layout actions">
        <FilterResultsIcon
          onClick   = { _toggleFilterResults }
          showLabel = { !isMobileOnly }
          className = { filtersIconActive ? ' active' : ''}
        />
        <div
          className={`${dropdownClasses} ${dropdownOpen ? 'rs-dropdown-open' : '' }`}
          role="menu"
        >
          <ul className="rs-dropdown-menu rs-dropdown-menu-active" role="menu">
            {
              _sortDropdownOptions.map((item, key) => (
                <Dropdown.Item
                  key     = {v4()}
                  active  = { state.sort == item.value }
                  onClick = { () => __handleSortClick(item) }
                >
                  <i className={ item.icon } />
                  <span>{ item.label }</span>
                </Dropdown.Item>
              ))
            }
          </ul>
          <a tabindex="0" class="rs-btn rs-btn-subtle rs-dropdown-toggle" onClick={toggleDropdown}>
            {mainSortIcon}
            {!isMobileOnly && <span>Sort</span>}
          </a>
        </div>
        <button
          className={`icon grid ${state.layout === 'grid' && 'active'}`}
          aria-label="Grid Results View"
          role = "button"
          onClick={() => setLayout('grid')}>
          <Grid />
        </button>
        <button
          className={`icon list-icon rows ${state.layout === 'list' && 'active'}`}
          aria-label="List Results View"
          role = "button"
          onClick={() => setLayout('list')}>
          <List />
        </button>
        { smallScreen && <button
          className={`icon map-icon rows ${state.layout === 'map' && 'active'}`}
          aria-label="Map Results View"
          role = "button"
          onClick={() => _handleMapButtonClick()}>
            <Pin />
          </button>
        }
      </nav>
    </div>
  )
}

export default SearchFilter
